// extracted by mini-css-extract-plugin
module.exports = {"upgradeDrawer":"style_upgradeDrawer__EMw_h","title":"style_title__TyikZ"};